import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
  ListItemIcon,
  Divider,
  Box,
  Typography
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import DeselectIcon from "@mui/icons-material/IndeterminateCheckBox";

const opcionesFiltros = [
  { value: 'cliente', label: 'Cliente' },
  { value: 'direccion', label: 'Dirección' },
  { value: 'localidad', label: 'Localidad' },
  { value: 'telefono', label: 'Teléfono' },
  { value: 'cuit', label: 'CUIT' },
  { value: 'sisven', label: 'SISVEN' }
];

const SelectorFiltrosMultiples = ({ filtrosSeleccionados, onFiltrosChange }) => {
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleOpenMenu = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleToggleFiltro = (filtroValue) => {
    const nuevosFiltros = filtrosSeleccionados.includes(filtroValue)
      ? filtrosSeleccionados.filter(f => f !== filtroValue)
      : [...filtrosSeleccionados, filtroValue];
    
    onFiltrosChange(nuevosFiltros);
  };

  const handleSelectAll = () => {
    onFiltrosChange(opcionesFiltros.map(f => f.value));
  };

  const handleClearAll = () => {
    onFiltrosChange([]);
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={handleOpenMenu}
        startIcon={<FilterListIcon sx={{ color: 'grey.700' }} />}
        endIcon={<ArrowDropDownIcon sx={{ color: 'grey.700' }} />}
        sx={{
          minWidth: '160px',
          justifyContent: 'space-between',
          backgroundColor: 'white',
          borderColor: 'grey.300',
          color: 'grey.700',
          textTransform: 'none',
          fontWeight: '400',
          '&:hover': {
            backgroundColor: 'grey.50',
            borderColor: 'grey.400'
          }
        }}
      >
        {filtrosSeleccionados.length > 0 ? (
          <Box sx={{ display: 'flex', alignItems: 'center',height: 32, gap: 0.5 }}>
            <span>Filtros</span>
            <Box 
              sx={{ 
                backgroundColor: 'grey.200', 
                borderRadius: '50%', 
                width: 20, 
                height: 20, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                fontSize: '0.75rem',
                fontWeight: '500'
              }}
            >
              {filtrosSeleccionados.length}
            </Box>
          </Box>
        ) : (
          "Campos de búsqueda"
        )}
      </Button>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
        disableAutoFocus
        disableEnforceFocus
        keepMounted
        PaperProps={{
          sx: {
            maxHeight: 320,
            width: '260px',
            mt: 1,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '1px solid',
            borderColor: 'grey.200'
          },
        }}
      >
        <MenuItem disabled sx={{ py: 1 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              color: 'grey.700',
              fontWeight: '600',
              fontSize: '0.875rem'
            }}
          >
            Campos de búsqueda
          </Typography>
        </MenuItem>
        
        {opcionesFiltros.map((filtro) => (
          <MenuItem
            key={filtro.value}
            onClick={() => handleToggleFiltro(filtro.value)}
            sx={{ py: 1 }}
          >
            <Checkbox
              checked={filtrosSeleccionados.includes(filtro.value)}
              onChange={() => {}}
              sx={{ 
                color: 'grey.400',
                '&.Mui-checked': {
                  color: 'grey.600',
                }
              }}
            />
            <ListItemText 
              primary={
                <Typography variant="body2" sx={{ color: 'grey.700' }}>
                  {filtro.label}
                </Typography>
              } 
            />
          </MenuItem>
        ))}
        
        <Divider sx={{ my: 0.5 }} />
        
        <MenuItem 
          onClick={handleSelectAll}
          sx={{ py: 1 }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <SelectAllIcon 
              fontSize="small" 
              sx={{ color: 'grey.600' }} 
            />
          </ListItemIcon>
          <ListItemText 
            primary={
              <Typography variant="body2" sx={{ color: 'grey.700' }}>
                Seleccionar todos
              </Typography>
            } 
          />
        </MenuItem>
        
        <MenuItem 
          onClick={handleClearAll}
          sx={{ py: 1 }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <DeselectIcon 
              fontSize="small" 
              sx={{ color: 'grey.600' }} 
            />
          </ListItemIcon>
          <ListItemText 
            primary={
              <Typography variant="body2" sx={{ color: 'grey.700' }}>
                Limpiar selección
              </Typography>
            } 
          />
        </MenuItem>

        <Box 
          sx={{ 
            px: 2, 
            py: 1, 
            borderTop: '1px solid', 
            borderColor: 'grey.100',
            backgroundColor: 'grey.50'
          }}
        >
          <Typography 
            variant="caption" 
            sx={{ color: 'grey.600' }}
          >
            {filtrosSeleccionados.length} de {opcionesFiltros.length} seleccionados
          </Typography>
        </Box>
      </Menu>
    </>
  );
};

export default SelectorFiltrosMultiples;